<div class="raw-content-page-layout">
  <!-- Brand Resources -->
  <oth-hero [contents]="[{text: 'Brand Resources', level: 1}]"></oth-hero>
  <app-policy-card [policyBody]="body">
    <!-- Body -->
    <ng-template #body>
      <div class="policy-content" i18n="@@brandingPage.policyContent">
        <p>
          {{ 'All of ' + BRAND.name + '’s brand features including ' }}<strong>{{ BRAND.name }}</strong>
          and the
          <strong>{{ BRAND.name }}</strong> logo are protected by applicable
          trademark, copyright and other intellectual property laws. Any use of a
          <strong>{{ BRAND.name + ' trademark'}}</strong> is subject to the
          <strong>{{ BRAND.name + ' Trademark Standards'}}</strong> for Use.
        </p>
        <p>
          Basic usage guidelines can be found below. If you have any questions or want to request approval to use
          these
          assets, please do not hesitate to contact us or email <a
            [href]="'mailto:' + environmentCommon.company.email">{{ environmentCommon.company.email }}</a>
        </p>
        <br/>
        <p>
          <strong>
            Basic Usage Guidelines:
          </strong>
        </p>
        <p>
          - Do not rotate the <strong>{{ BRAND.name }}</strong> logo.
        </p>
        <p>
          - Do not change the color of the <strong>{{ BRAND.name }}</strong> logo.
        </p>
        <p>
          - Do not distort the <strong>{{ BRAND.name }}</strong> logo (be sure to scale proportionately).
        </p>
        <p>
          - Allow an appropriate amount of white space around the <strong>{{ BRAND.name }} </strong>logo, at least
          as much as the x-height of
          the logo (suggested).
        </p>
        <p>
          - Preferred minimum size for the <strong>{{ BRAND.name }}</strong> logo is 100px wide. For smaller sizes,
          you must seek permission
          from the <strong>{{ BRAND.name }} </strong> team.
        </p>
      </div>
    </ng-template>
  </app-policy-card>

  <!-- Color Palette -->
  <oth-hero [contents]="[{text: 'Color Palette', level: 2}]"></oth-hero>
  <div class="branding-resources-wrapper">
    <app-asset-card
        [assetItemClass]="'color-item'"
        [href]="colorPalette.brandColor ? externalColorInfoUrl + colorPalette.brandColor.substring(1, colorPalette.brandColor.length) : ''"
        [secondaryText]="colorPalette.brandColor | uppercase"
        [title]="'Brand Color'">
    </app-asset-card>
    <app-asset-card
        [assetItemClass]="'color-item secondary'"
        [href]="colorPalette.secondaryColor ? externalColorInfoUrl + colorPalette.secondaryColor.substring(1, colorPalette.secondaryColor.length) : ''"
        [secondaryText]="colorPalette.secondaryColor | uppercase"
        [title]="'Secondary Color'">
    </app-asset-card>
    <app-asset-card
        [assetItemClass]="'color-item tertiary'"
        [href]="colorPalette.tertiaryColor ? externalColorInfoUrl + colorPalette.tertiaryColor.substring(1, colorPalette.tertiaryColor.length) : ''"
        [secondaryText]="colorPalette.tertiaryColor | uppercase"
        [title]="'Tertiary Color'">
    </app-asset-card>
  </div>

  <!-- Logos -->
  <oth-hero [contents]="[{text: 'Logos', level: 2}]"></oth-hero>
  <div class="branding-resources-wrapper">
    <app-asset-card [assetItemClass]="'logo-item'"
                    [href]="BRAND.logo.main.replace('min/', '').replace('.min', '')"
                    [secondaryText]="'PNG'"
                    [src]="BRAND.logo.main"
                    [title]="BRAND.logo.main.substring( BRAND.logo.main.lastIndexOf( '/' ) + 1, BRAND.logo.main.lastIndexOf( '.min.png' ) )"
                    imgHeight="175">
    </app-asset-card>
  </div>

  <!-- Wallpapers -->
  <oth-hero [contents]="[{text: 'Wallpapers', level: 2}]"></oth-hero>
  <div class="branding-resources-wrapper">
    <ng-container *ngFor="let wallpaper of BRAND.wallpapers; index as i">
      <app-asset-card [assetItemClass]="'wallpaper-item'" [href]="wallpaper.replace('min/', '').replace('.min', '')"
                      [imgHeight]="400"
                      [secondaryText]="'PNG'" [src]="wallpaper"
                      [title]="wallpaper.substring( wallpaper.lastIndexOf( '/' ) + 1, wallpaper.lastIndexOf( '.min.png' ) )">
      </app-asset-card>
    </ng-container>
  </div>
</div>
